import type React from 'react'

import { cn } from '@/utils'
import { PopoverContent } from '@/components/ui/popover'

import { POPOVER_CLASS } from '../constants/format-control-classes'

interface FormatPopoverContentProps {
  /** Merged after `POPOVER_CLASS` — the popover's width and padding. */
  className?: string
  onRestoreFocus?: () => void
  children: React.ReactNode
}

/**
 * The popover body every Format Text control opens: below the trigger, start-aligned, 8px off.
 *
 * Every popover here portals to `document.body` via Radix, which is why each one carries its own
 * `data-text-edit-keepalive` and an explicit z-index (`POPOVER_CLASS`): the attribute on the
 * toolbar root does NOT reach a portalled child. `onCloseAutoFocus` hands focus back to the text
 * field instead of Radix's default of the trigger — see `ControlProps.onRestoreFocus`.
 */
export function FormatPopoverContent({
  className,
  onRestoreFocus,
  children,
}: FormatPopoverContentProps) {
  return (
    <PopoverContent
      side="bottom"
      align="start"
      sideOffset={8}
      className={cn(POPOVER_CLASS, className)}
      data-text-edit-keepalive=""
      onCloseAutoFocus={(e) => {
        e.preventDefault()
        onRestoreFocus?.()
      }}
    >
      {children}
    </PopoverContent>
  )
}
